import {isNil} from 'ramda';

/**
 * Calculates price excluding VAT from the gross price and VAT rate.
 *
 * Handles both decimal (0.21) and percentage (21) VAT rate formats.
 * Returns null if the input price or vat rate is null.
 */
export function calculatePriceExclVat(
  grossPrice: number | null | undefined,
  vatRate: number | null | undefined
): number | null {
  if (isNil(grossPrice) || isNil(vatRate)) {
    return null;
  }
  const normalized = vatRate > 1 ? vatRate / 100 : vatRate;
  return Math.round(grossPrice / (1 + normalized));
}
